import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext();

export const useChat = () => {
  return useContext(ChatContext);
};

export const ChatProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [emptyChat, setEmptyChat] = useState(false);

  const addMessage = (message, role) => {
    setMessages((prevMessages) => [
      ...prevMessages,
      { content: message, role },
    ]);
    setEmptyChat(false);
  };

  const resetChat = () => {
    setMessages([]);
    setEmptyChat(true);
  };

  const value = {
    emptyChat,
    messages,
    addMessage,
    resetChat,
  };

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};
